import React from 'react'
import { MenuItem } from '../../portal/PortalLayout'

export const STUDENT_MENU_ITEMS: MenuItem[] = [
  {
    label: 'Dashboard',
    path: '/student/dashboard',
    icon: <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'><rect x='3' y='3' width='7' height='7' rx='1'/><rect x='14' y='3' width='7' height='7' rx='1'/><rect x='3' y='14' width='7' height='7' rx='1'/><rect x='14' y='14' width='7' height='7' rx='1'/></svg>,
  },
  {
    label: 'My Info',
    path: '/student/dashboard/student-info',
    icon: <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'><path d='M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2'/><circle cx='12' cy='7' r='4'/></svg>,
  },
  {
    label: 'Navigator 360',
    path: '/student/dashboard/navigator-360',
    icon: <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'><circle cx='12' cy='12' r='10'/><path d='M16.24 7.76l-2.12 6.36-6.36 2.12 2.12-6.36 6.36-2.12z'/></svg>,
  },
  {
    label: 'Assessments',
    path: '/student/dashboard/assessments',
    icon: <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'><path d='M9 11l3 3L22 4'/><path d='M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11'/></svg>,
  },
  {
    label: 'My Reports',
    path: '/student/dashboard/reports',
    icon: <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'><path d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z'/><polyline points='14 2 14 8 20 8'/><line x1='16' y1='13' x2='8' y2='13'/><line x1='16' y1='17' x2='8' y2='17'/></svg>,
  },
  {
    label: 'Counselling',
    path: '/student/dashboard/counselling',
    icon: <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'><path d='M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z'/></svg>,
  },
  {
    label: 'Career Library',
    path: 'student-career-library',
    externalHref: 'https://library.career-9.com/',
    icon: <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'><path d='M4 19.5A2.5 2.5 0 0 1 6.5 17H20'/><path d='M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z'/><path d='M8 7h8'/><path d='M8 11h6'/></svg>,
  },
]

// Phase 19 (19-02): removed 'studentPortalProfile' and 'studentPortalLoggedIn' —
// auth state lives in the unified cookie session (cn_at) + useAuth() now, never
// in localStorage. 'studentPortalDashboard' is dashboard-data cache (not auth)
// and remains until a future plan migrates it to a server fetch.
export const STUDENT_STORAGE_KEYS = ['studentPortalDashboard']
